import { render, staticRenderFns } from "./JoinContact.vue?vue&type=template&id=3dcb3cea"
import script from "./JoinContact.vue?vue&type=script&lang=js"
export * from "./JoinContact.vue?vue&type=script&lang=js"
import style0 from "./JoinContact.vue?vue&type=style&index=0&id=3dcb3cea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports